import { Link, useLocation } from "react-router-dom";
import { Users } from "lucide-react";

// Hide on these routes (Home itself, public/auth, admin shell which has its own nav).
const HIDDEN_PREFIXES = [
  "/dashboard",
  "/auth",
  "/welcome",
  "/pending",
  "/apply",
  "/pricing",
  "/valuation",
  "/redeem",
  // Public sign-up / purchase pages — no shortcut into the member area.
  "/get-started",
  "/membership",
  "/checkout",
  "/admin",
  // Full-viewport simulation mode owns the whole screen.
  "/sim",
  // Community has its own "← Kingdom Hub" header link.
  "/community",
  "/profile",
  "/progress",
  "/metrics",
];

export default function BackToFloor() {
  const { pathname } = useLocation();
  return null;
  if (pathname === "/") return null;
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"))) {
    return null;
  }
  return (
    <Link
      to="/dashboard"
      className="fixed bottom-4 left-4 z-[60] hidden md:inline-flex items-center gap-1.5 h-9 px-3 rounded-full border border-gold/40 bg-[hsl(0_0%_4%/0.92)] backdrop-blur-md text-[10px] uppercase tracking-[0.2em] font-semibold text-gold shadow-[0_8px_24px_hsl(0_0%_0%/0.6)] hover:bg-gold/15 transition-colors"
      title="Back to the Floor"
    >
      <Users className="h-3.5 w-3.5" />
      ← The Floor
    </Link>
  );
}